import { ThemeColors } from '~/themes/colors'

interface SnippetsColors {
  Header: {
    Background: ThemeColors
  }
  DeleteButton: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
    }
  }
  ListView: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
    Items: {
      Background: ThemeColors
      Border: ThemeColors
    }
  }
  EditView: {
    Background: ThemeColors
    Border: ThemeColors
    Input: {
      Background: ThemeColors
      Border: ThemeColors
      Prefix: {
        Background: ThemeColors
        FontColor: ThemeColors
      }
    }
    HelperText: {
      FontColor: ThemeColors
    }
    CancelButton: {
      Background: {
        Default: ThemeColors
        Hover: ThemeColors
        Active: ThemeColors
      }
      FontColor: {
        Active: ThemeColors
      }
    }
  }
}

export const snippetsColors: SnippetsColors = {
  Header: {
    Background: {
      default: 'gray.100',
    },
  },
  DeleteButton: {
    Background: {
      Default: {
        default: 'gray.800',
      },
      Hover: {
        default: 'gray.1300',
      },
    },
  },
  ListView: {
    Background: {
      Default: {
        default: 'gray.100',
      },
      Hover: {
        default: 'gray.400',
      },
      Active: {
        default: 'gray.500',
      },
    },
    Items: {
      Background: {
        default: 'achromatic.transparent',
      },
      Border: {
        default: 'gray.400',
      },
    },
  },
  EditView: {
    Background: {
      default: 'achromatic.transparent',
    },
    Border: {
      default: 'gray.400',
    },
    Input: {
      Background: {
        default: 'gray.100',
      },
      Border: {
        default: 'gray.800',
      },
      Prefix: {
        Background: {
          default: 'gray.300',
        },
        FontColor: {
          default: 'gray.800',
        },
      },
    },
    HelperText: {
      FontColor: {
        default: 'gray.800',
      },
    },
    CancelButton: {
      Background: {
        Default: {
          default: 'red.800',
        },
        Hover: {
          default: 'red.600',
        },
        Active: {
          default: 'red.900',
        },
      },
      FontColor: {
        Active: {
          default: 'red.600',
        },
      },
    },
  },
}
